/* global Modernizr */

import 'jquery-hoverintent';

const $navigation = $('.js-navigation');
const DROPDOWN_TOGGLER_SELECTOR = '.js-dropdown-toggler';

const isTouchDevice = () => Modernizr.touchevents;

const navigation = {
  initialize() {
    if ($navigation.length) {
      this.createEvents();

      window.addEventListener('pageshow', () => {
        this.loadCartCount();
      });
    }
  },

  createEvents() {
    if (isTouchDevice()) {
      $(DROPDOWN_TOGGLER_SELECTOR).on('click', (e) => {
        e.preventDefault();

        const target = e.currentTarget;
        const isOpen = target.getAttribute('aria-expanded') === 'true';

        if (isTouchDevice()) {
          if (!isOpen) {
            this.closeOpenMenus();
          }

          this.setActiveStateOnMenuItem(target, !isOpen);
        }
      });

      $('body').on('click', (e) => {
        if (e.target.closest('.navigation')) {
          return true;
        }

        this.closeOpenMenus();

        return true;
      });
    } else {
      $(DROPDOWN_TOGGLER_SELECTOR).parent()
        .hoverIntent((e) => {
          const target = e.currentTarget.querySelector(DROPDOWN_TOGGLER_SELECTOR);
          this.setActiveStateOnMenuItem(target, true);
        }, (e) => {
          const target = e.currentTarget.querySelector(DROPDOWN_TOGGLER_SELECTOR);
          this.setActiveStateOnMenuItem(target, false);
        });
    }
  },

  closeOpenMenus() {
    const $openDropdowns = $(DROPDOWN_TOGGLER_SELECTOR).filter('[aria-expanded="true"]');

    $openDropdowns.each((index, element) => {
      this.setActiveStateOnMenuItem(element, false);
    });
  },

  setActiveStateOnMenuItem(target, isOpen) {
    const dropdown = target.getAttribute('aria-controls')
      ? document.getElementById(target.getAttribute('aria-controls'))
      : null;

    if (!dropdown) {
      return;
    }

    target.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    dropdown.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

    target.classList[isOpen ? 'add' : 'remove']('is-open');
  },

  loadCartCount() {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(() => {
        this.fetchCartAndSetCount();
      });
    } else {
      this.fetchCartAndSetCount();
    }
  },

  fetchCartAndSetCount() {
    $.ajax({
      url: '/api/cart',
      success: (res) => {
        if (typeof res.count !== 'undefined') {
          $('.js-header-cart-items').text(res.count);
          if (res.count) {
            $('.js-header-cart-items').removeClass('d-none');
          }
        }
      },
      error: () => {
        //
      },
    });
  },
};

export default navigation;
